/** @typedef {ServiceWorkerRegistration} ServiceWorkerRegistration */

export const PWA_UPDATE_AVAILABLE = 'pwa-update-available'
export const PWA_OFFLINE_READY = 'pwa-offline-ready'

/**
 * @param {string} name
 * @param {unknown} [detail]
 */
export function dispatchPWAEvent(name, detail) {
  if (typeof window === 'undefined') return
  window.dispatchEvent(new CustomEvent(name, { detail }))
}

/**
 * @param {Event} event
 * @returns {ServiceWorkerRegistration | null}
 */
export function getRegistrationFromPWAEvent(event) {
  const detail = /** @type {{ registration?: ServiceWorkerRegistration } | undefined} */ (
    event.detail
  )
  return detail?.registration ?? null
}
